import { FormattedMessage } from "react-intl";

import { Text } from "@/components/atoms/Text";

import { DepositMinimumSpendDetails } from "./DepositMinimumSpendDetails";

type HowMinimumSpendWorksProps = {
  useDepositCopy: boolean;
  categoryPhrase: string;
};

/**
 * FAQ body for the listing page minimum spend accordion; copy differs for deposit vs prepaid minimum.
 */
const HowMinimumSpendWorks = ({
  useDepositCopy,
  categoryPhrase,
}: HowMinimumSpendWorksProps) => {
  if (useDepositCopy)
    return <DepositMinimumSpendDetails categoryPhrase={categoryPhrase} />;

  return (
    <div className="tw-flex tw-flex-col tw-gap-16">
      <Text typeface="body-2">
        <FormattedMessage defaultMessage="When you reserve, you'll pay for the space. During your event, the food and beverage orders of you and your guests will go towards the venue's minimum spend." />
      </Text>
      <ul className="tw-list-disc tw-list-outside tw-space-y-8 tw-pl-24">
        <Text typeface="body-2" element="li">
          <FormattedMessage defaultMessage="Most venues allow you to split tabs between you and your guests." />
        </Text>
        <Text typeface="body-2" element="li">
          <FormattedMessage defaultMessage="Minimum spend does not include tax and tip." />
        </Text>
        <Text typeface="body-2" element="li">
          <FormattedMessage defaultMessage="At the end of your event, you will be responsible for any portion of the minimum that your party did not meet." />
        </Text>
      </ul>
    </div>
  );
};

export default HowMinimumSpendWorks;
